import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";

const ICONS = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
  warn: AlertCircle,
};

export default function TdsFeedbackBanner({ message, type = "success", onClose }) {
  const Icon = ICONS[type] || CheckCircle2;

  return (
    <AnimatePresence>
      {message ? (
        <motion.div
          key={message}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.25 }}
          className={`tds-alert tds-alert--${type}`}
          role="status"
          aria-live="polite"
        >
          <Icon size={18} className="shrink-0" />
          <span className="flex-1 font-semibold">{message}</span>
          {onClose ? (
            <button
              type="button"
              onClick={onClose}
              className="p-1 rounded-md hover:bg-black/5 shrink-0"
              aria-label="Dismiss"
            >
              <X size={16} />
            </button>
          ) : null}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
